import React, { useRef, useEffect, useState } from "react";
import logo from "../../img/mnid-logo.png";
import logoConnect from "../../img/mnid-logo-2.png";
import { MoonOutline, Refresh, SunOutline } from "../../svg/Icons";
import { useTheme } from "../Context/ThemeContext";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useLocalStorage } from "../Context/LocalStorageContext";
import { useResetDemo} from "../ResetDemo";
import GoogleAnalytics from "../GA";


function Header(props: any) {
 
    const resetDemo = useResetDemo();
    const navigate= useNavigate();
    const [darkTheme, toggleTheme] = useTheme();
    const [mpk, setMpk] = useLocalStorage("mpk");
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    const [shadowIntensity1, setShadowIntensity1] = useState(0);
    const [shadowIntensity2, setShadowIntensity2] = useState(0);

    // Function to handle the scroll event
    const handleScroll = () => {
        const scrollY = window.scrollY;
        // Calculate shadow intensity based on scroll position
        const maxScroll = 40;
        const intensity = Math.min(scrollY / maxScroll, 1) / 10; // Cap intensity at 1 (100%) and divide by 10 (max is 10% shadow)
        const intensity2 = Math.min(scrollY / maxScroll, 1) / 25; // Cap intensity at 1 (100%) and divide by 10 (max is 10% shadow)

        setShadowIntensity1(intensity);
        setShadowIntensity2(intensity2);
    };

    // Add scroll event listener on component mount and clean up on unmount
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

   function resetDemoCode(){
        setMpk(null); 
        //searchParams.delete("id_token");
        //setSearchParams(searchParams);
        resetDemo();
        
   }

    return (<>
        {/* Header for connect page */}
        { location.pathname.includes("/connect") ? 
            <header className="sm:h-[106px] sticky top-0 z-10 flex w-full justify-center bg-primary-50 text-primary-700" style={{
                boxShadow: `0 20px 25px -5px rgba(81, 69, 205, ${shadowIntensity1}), 0 10px 10px rgba(81, 69, 205, ${shadowIntensity2})`, // Apply dynamic shadow intensity
            }}>
                <div className="flex w-[1280px] flex-col gap-8 pt-8 pb-4 sm:py-8 px-6 sm:px-12">
                    <div className="flex flex-col gap-6 sm:flex-row items-center justify-between sm:gap-0">
               
                        <div className="flex gap-6">
                            <img
                                src={logoConnect}
                                alt="MNID Logo"
                                width="40"
                                height="40" />
                            <h1 className="underline-custom-connect relative inline-block px-2 font-poppins text-[32px] font-bold leading-[40px] text-primary-700">
                                IDT++ Demo
                            </h1>
                        </div>

                        <div className="justify-end flex flex-row gap-4">
                            {mpk && 
                                <button className="bg-transparent py-2 px-[12px] flex gap-2 items-center border border-none text-primary-700 dark:text-gray-200 dark:border-gray-200" onClick={() => {resetDemoCode(); GoogleAnalytics("navigation", "btn_resetDemo", "Button to reset demo")}}>
                                    <Refresh className="size-5 text-primary-700"/>Restart the demo
                                </button>
                            }

                            {/*<button className="button-transparent" onClick={toggleTheme} >
                                {!darkTheme ? <MoonOutline className="size-5 text-white" /> : <SunOutline className="size-5 text-gray-400" /> }
                            </button>*/}
                          
                        </div>
                    </div>
                </div>
            </header>

            :

            <header className="sm:h-[106px] sticky top-0 z-10 flex w-full justify-center bg-gradient-to-r from-lightGradient1 to-lightGradient2 backdrop-blur-sm dark:from-darkGradient1 dark:to-darkGradient2" style={{
                boxShadow: `0 20px 25px -5px rgba(81, 69, 205, ${shadowIntensity1}), 0 10px 10px rgba(81, 69, 205, ${shadowIntensity2})`, // Apply dynamic shadow intensity
            }}>
                <div className="flex w-[1280px] flex-col gap-8 pt-8 pb-4 sm:py-8 px-6 sm:px-12">
                    <div className="flex flex-col gap-6 sm:flex-row items-center justify-between sm:gap-0">
                        <div className="flex gap-6">
                            <img
                                src={logo}
                                alt="MNID Logo"
                                width="40"
                                height="40" />
                            <h1 className="underline-custom relative inline-block px-2 font-poppins text-[28px] sm:text-[32px] font-bold leading-[40px] text-white">
                                IDT++ Demo
                            </h1>
                        </div>
    
                        <div className="justify-end flex flex-row gap-4">
                            {mpk && 
                                <button className="button-transparent sm:border sm:border-white dark:text-gray-200 dark:border-gray-200" onClick={() => {resetDemoCode(); GoogleAnalytics("navigation", "btn_resetDemo__connect", "Button to reset demo on connect")}}>
                                     <Refresh className="size-[20px] text-white"/>Restart the demo
                                </button>
                            }
                            
                            {/*<button className="button-transparent" onClick={toggleTheme} >
                                {!darkTheme ? <MoonOutline className="size-5 text-white" /> : <SunOutline className="size-5 text-gray-400" /> }
                            </button>*/}
                           
                        </div>
                    </div>
                 
                </div>
            </header>
        }
        
    </>);
}

export default Header;
